export default {
    owner: 'Owner',
    dependent: 'Dependent',
    birth: 'Birth: ',
    identification: 'Identification ',
    age: 'Age ',
    sex: 'Sex',
    male: 'Male',
    female: 'Female',
    totalResults: ' Items found',
    selectBeneficiary: 'Select a beneficiary ',
    notItemsFound: {
        title: 'No matches found',
        description: 'Review the terms used in the search',
        descriptionPrefix: 'or try a ',
        descriptionSufix:'new search'         
    }
}